import { useDynamicRecsDeprecated } from '@thd-nucleus/data-sources/react/dataModel/migration';

export const useFallback = ({ itemId, storeId, skip }) => {
  return useDynamicRecsDeprecated({
    itemId,
    domains: ['fbt'],
    storeId,
    productDomains: ['identifiers', 'info', 'media', 'pricing', 'reviews', 'details'],
    skip,
    ssr: false,
    skipSpecificationGroup: true
  });
};
